import React from 'react'

export const PageRendererLazy = React.lazy(() =>
  import('opensolar-pageeditor').then((module) => ({ default: module.OrgPageRenderer }))
)
